import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      modalZohoAgreement: {
        name: 'modalZohoAgreement',
        path: 'Zoho/ModalZohoAgreement',
        buttons: [
          {
            action: 'acceptAgree',
            text: 'Akceptuję',
            theme: 'purple',
            space: 'none',
          },
        ],
      },
    };
  },
  methods: {
    ...mapMutations({
      pushModal: 'modal/pushModal',
    }),
    loadZohoChat(showChat) {
      this.$helper.loadInlineScript(
        `var $zoho = $zoho || {};
              $zoho.salesiq = $zoho.salesiq || {
                widgetcode: '429c68585fd2941a35c4c0726de2afe54ab50b4df4963630c52ebeae764b7285',
                values: {},
                ready: function () {
                 $zoho.salesiq.floatbutton.visible("show");
                 
                 if (showChat) {
                  $zoho.salesiq.floatwindow.open();
                 }
                }
              };`,
        'zsiqscript_inline',
      );
      this.$helper.loadScript('https://salesiq.zoho.eu/widget', 'zsiqscript');
      if (showChat) {
        setTimeout(() => {
          // eslint-disable-next-line no-undef
          $zoho.salesiq.floatwindow.open();
        }, 2000);
      }
    },
    hideChat() {
      if (
        typeof $zoho !== 'undefined' &&
        // eslint-disable-next-line no-undef
        $zoho.salesiq &&
        // eslint-disable-next-line no-undef
        $zoho.salesiq.floatbutton &&
        // eslint-disable-next-line no-undef
        $zoho.salesiq.floatwindow
      ) {
        // eslint-disable-next-line no-undef
        $zoho.salesiq.floatbutton.visible('hide');
        // eslint-disable-next-line no-undef
        $zoho.salesiq.floatwindow.close();
      }
    },
    showChat(e) {
      e.preventDefault();
      if (typeof $zoho !== 'undefined') {
        // eslint-disable-next-line no-undef
        $zoho.salesiq.floatwindow.open();
      } else {
        this.pushModal({ modal: this.modalZohoAgreement });
      }
    },
  },
};
